export const jurosCorrecaoFields = [
    {key: "indexadorCorrecaoPercentual", label: "Indexador Correção Percentual", required: true, md: 4},
    {key: "defasagem", label: "Defasagem", required:true, type: "number", inputProps: {step: "1"}, defaultValue: 0},
    {key: "calculoDiasIndexador", label: "Cálculo Dias Indexador", required:true, md: 4},
    {key: "formulaIndexador", label: "Fórmula Indexador", required:true, md: 4},
    {key: "calculoDias", label: "Cálculo Dias", required:true, md: 4},
    {key: "jurosCapitalizacao", label: "Juros Capitalização", required:true, md: 4},
    {key: "periodicidadeAtualizacaoMonetaria", label: "Periodicidade Atualização Monetária", type: "number", md: 4},
    {key: "mesAniversarioAnualSEmestral", label: "Mês Aniversário Anual Semestral", md: 4},
    {key: "projecaoInflacao", label: "Projeção Inflação", type: "number", md: 4},
    {key: "inflacaoNegativa", label: "Inflação Negativa", type: "number", md: 4},
    {key: "recalculoProjecao", label: "Recálculo Projeção", type: "number", md: 4},
    {key: "aplicacaoAmortizacao", label: "Aplicação Amortização", required:true, md: 4},
    {key: "corrigeDataEvento", label: "Corrige Data Evento", required:true, md: 4},
]